module.exports = "<!-- https://localhost:4200/paymentsuccess?payment_id=MOJO8a03005A48930861&status=success -->\n\nPayment success"